
import React from 'react';

import * as d3 from 'd3';

import { Partitioner } from '../utils/Partitioner';

interface PartitionWidgetProps {
    partitioner: Partitioner;
    x: number;
    y: number;
    width: number;
    height: number;
}

class PartitionWidget extends React.Component<PartitionWidgetProps> {
    root: SVGGElement | null;

    constructor(props: PartitionWidgetProps) {
        super(props);

        this.root = null;
    }

    componentDidMount() {
        this.drawPartition();
    }

    componentDidUpdate() {
        this.drawPartition();
    }

    drawPartition() {
        const font_name = 'Trebuchet MS';
        let root = d3.select(this.root);
        root.selectAll('*').remove();

        const part = this.props['partitioner'];
        const line_height = this.props['height'] / (part.part_keys.length + 1);
        const font_size = line_height * 0.8;

        root.append('text')
            .attr('x', this.props['x'] + this.props['width'] / 2)
            .attr('y', this.props['y'] + line_height * 0.75)
            .attr('font-size', font_size)
            .attr('text-anchor', 'middle')
            .text(part.label_str + ':');

        let grps = root.append('g')
            .attr('transform', 'translate(' + this.props['x'] + ', ' + this.props['y'] + ')')
            .selectAll('g')
            .data(part.part_keys)
            .enter()
                .append('g');
            
        grps.append('rect')
                .attr('x', 0)
                .attr('y', d => this.props['height'] - line_height * (1 + part.part_keys.indexOf(d)))
                .attr('width', this.props['width'])
                .attr('height', line_height)
                .attr('fill', d => part.colors[part.part_keys.indexOf(d)])
        grps.append('text')
                .attr('x', this.props['width'] / 2)
                .attr('y', d => this.props['height'] - line_height * (part.part_keys.indexOf(d) + 0.25))
                .attr('font-size', font_size)
                .attr('text-anchor', 'middle')
                .attr('fill', d => d3.hsl(part.colors[part.part_keys.indexOf(d)]).l > 0.5 ? '#000000' : '#ffffff')
                .text(d => d);

        root.selectAll('text')
                .attr('font-family', font_name);
    }

    render() {
        return (
            <g ref={el => this.root = el}>
            </g>
        );
    }
}

export default PartitionWidget;